/**
 * Trustpilot bootstrap skips widgets in hidden UI (cart drawer). We re-run loadFromElement
 * when the drawer opens and after cart section HTML is swapped (fetch + replaceWith).
 *
 * Do not call loadFromElement on an already-rendered widget — a second call often strips
 * the stars and leaves only the fallback "Trustpilot" link text.
 */
(function () {
  var nudgeTimer;
  var pollTimer;

  function trustpilotApiReady() {
    return window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function';
  }

  /** Micro Star (and similar) inject iframe and/or SVG; unfilled markup is basically the seed <a> only */
  function trustpilotWidgetLooksRendered(el) {
    return !!(el.querySelector('iframe') || el.querySelector('svg'));
  }

  function loadCartTrustpilotWidgets() {
    if (!trustpilotApiReady()) return false;
    var list = document.querySelectorAll('cart-drawer .trustpilot-widget');
    if (!list.length) return true;
    list.forEach(function (el) {
      if (trustpilotWidgetLooksRendered(el)) return;
      try {
        window.Trustpilot.loadFromElement(el);
      } catch (e) {}
    });
    return true;
  }

  function runNudgeOrPoll() {
    if (loadCartTrustpilotWidgets()) return;
    var attempts = 0;
    if (pollTimer) clearInterval(pollTimer);
    pollTimer = setInterval(function () {
      if (loadCartTrustpilotWidgets() || ++attempts >= 50) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 120);
  }

  function scheduleNudge() {
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(runNudgeOrPoll, 450);
  }

  function watchCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var mo = new MutationObserver(function () {
      if (drawer.classList.contains('active')) scheduleNudge();
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /**
   * cart-drawer-items (includes trust block) and footer are replaceWith'd from section HTML
   * after cart updates (see assets/cart.js onCartUpdate). That removes Trustpilot's iframe —
   * we must hydrate again. Include all cartUpdate sources (including cart-items after qty change).
   */
  function subscribeCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      scheduleNudge();
      // Section replace (cart.js onCartUpdate) is async; first nudge can run before new DOM exists.
      setTimeout(runNudgeOrPoll, 1000);
    });
  }

  function init() {
    watchCartDrawerOpen();
    subscribeCartUpdates();
    scheduleNudge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', scheduleNudge);
})();
